import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { BankAccountSidePanelDetails } from "./BankAccountSidePanelDetails";

interface BankAccountSidePanelProps {
  bankAccountId: number
  trigger: JSX.Element
  fallbackIfNoPermission?: JSX.Element
}

export const BankAccountSidePanel = (props: BankAccountSidePanelProps) => {
  if (!site.permissions.canConfigureSystemSettings) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <DetailSidePanel
    apiCall={() => window.CoreApi.BankAccount.GetBankAccount(props.bankAccountId)}
    apiKey="bankAccount"
    entityId={props.bankAccountId}
    title={RESX.BankAccount.resxBankAccount}
    footerContent={<>
      {site.permissions.canConfigureSystemSettings && <ButtonPrimary href={routes.bankAccount_Detail(props.bankAccountId).absolute} label={RESX.Buttons.DetailView} />}
    </>}
    trigger={props.trigger}
  >
    {(bankAccount) => <BankAccountSidePanelDetails
      bankAccount={bankAccount}
    />}
  </DetailSidePanel>;
}